import * as types from "../actions/ActionTypes";

const defaultState = {
  carouselToSlider: false,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.CAROUSEL_TO_SLIDER:
      return Object.assign({}, state, {
        carouselToSlider: true,
      });

    case types.CAROUSEL_TO_SLIDER_RESET:
      return Object.assign({}, state, {
        carouselToSlider: false,
      });

    case "LOGOUT":
      return defaultState;
    default:
      return state;
  }
}
